import React from 'react';
import { FaBolt, FaHome, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center relative overflow-hidden">
          {/* Dekoratív elemek */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-600/20 via-red-600 to-red-600/20"></div>
          <div className="absolute -top-16 -right-16 w-32 h-32 bg-red-50 rounded-full blur-2xl opacity-60"></div>
          <div className="absolute -bottom-16 -left-16 w-32 h-32 bg-red-50 rounded-full blur-2xl opacity-60"></div>
          
          {/* 404 szám */}
          <div className="relative">
            <h1 className="text-8xl md:text-9xl font-bold text-gray-900 mb-4 animate-bounce">
              4
              <span className="inline-block mx-2">
                <FaBolt className="text-red-600 animate-pulse" />
              </span>
              4
            </h1>
          </div>

          {/* Üzenet */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            Hoppá! Ez az oldal nem található
          </h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Sajnáljuk, de a keresett oldal nem található. 
            Lehet, hogy törölték, átnevezték, vagy soha nem is létezett.
          </p>

          {/* Gombok */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="group bg-red-600 text-white px-6 py-3 rounded-xl font-semibold 
                flex items-center justify-center gap-2 transition-all duration-300 
                hover:bg-red-700 hover:shadow-lg hover:shadow-red-600/30"
            >
              <FaHome className="text-xl group-hover:scale-110 transition-transform" />
              Vissza a főoldalra
            </Link>
            <Link 
              to="/contact"
              className="group bg-gray-900 text-white px-6 py-3 rounded-xl font-semibold 
                flex items-center justify-center gap-2 transition-all duration-300 
                hover:bg-gray-800 hover:shadow-lg hover:shadow-gray-900/30"
            >
              <FaSearch className="text-xl group-hover:scale-110 transition-transform" />
              Segítségre van szüksége?
            </Link>
          </div>

          {/* Extra info */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-gray-500 text-sm">
              Kód: 404 | Oldal nem található
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 